import React, { useState, useEffect } from "react";
import TopNav from "../layouts/TopNav";
import { FaUser, FaPlus } from "react-icons/fa";
import { BiDotsVerticalRounded } from "react-icons/bi";
import "../Styles/customer.css";
import AddCustomer from "../components/Modals/AddCustomer";
import { ToastContainer, toast } from "react-toastify";
import FundWallet from "../components/Modals/FundWallet";
import EditDelete from "../components/Modals/Edit&Delete";
import { BsSearch } from "react-icons/bs";
import TablePagination from "@mui/material/TablePagination";
import Swal from "sweetalert2";
import BanksTable from "../components/Modals/BanksTable";
import { useNavigate } from "react-router-dom";
import Option from "../components/Option";
import { FiUsers } from "react-icons/fi";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

type Customer = {
  businessName: string;
  _id: string;
  customerAccount: any;
  customer: string;
  state: string;
  country: string;
};

const Customers = ({ isOpen }: any) => {
  const navigate = useNavigate();
  const [addCus, setAddCus] = useState(false);
  const [fund, setFund] = useState(false);
  const [cusID, setCusId] = useState("");
  const [option, setOption] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [reLogin, setReLogin] = useState(false);
  const [getUserBank, setGetUserBank] = useState({});
  const [userRole, setUserRole] = useState("");

  const handleOption = (customer: any) => {
    setSelectedCustomer(customer);
    setOption(!option);
  };

  const handleFund = (user: any) => {
    setFund(!fund);
    setCusId(user?.customerAccount?.map((c: any) => c._id));
    setGetUserBank(user?.customerAccount);
  };

  const handleCus = () => {
    setAddCus(!addCus);
    if (addCus) {
      setSign({
        businessName: "",
        businessType: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        country: "",
        amount: "",
        product: "",
        bank: "",
      })
    }
  };

  const [getCustomer, setGetCustomer] = useState<Customer[]>([]);
  const token = window.localStorage.getItem("token");

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/customer", {
        headers: headers,
      })
      .then((res) => {
        setGetCustomer(res.data.data);
        const userRole = res.data.data[0]?.role;
        setUserRole(userRole);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error("Error fetching customers");
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const [loading, setLoading] = useState(false);

  const [sign, setSign] = useState({
    businessName: "",
    businessType: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    amount: "",
    product: "",
    bank: "",
  });

  const handleChanges = ({ target: { name, value } }: any) => {
    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .post(
        "/customer",
        {
          businessName: sign.businessName,
          email: sign.email,
          phone: sign.phone,
          businessType: sign.businessType,
          address: sign.address,
          city: sign.city,
          state: sign.state,
          country: sign.country,
        },
        { headers: headers }
      )
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
        setAddCus(false);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {

          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  // Add funds
  const [funding, setFunding] = useState({
    customerWallet: "",
    bank: "",
  });

  const handleFundChange = ({ target: { name, value } }: any) => {
    setFunding((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };

  const handleFundSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    console.log(cusID, funding.customerWallet);

    api
      .patch(
        `/customer/${cusID}`,
        {
          customerWallet: funding.customerWallet,
        },
        { headers: headers }
      )
      .then((res) => {
        setLoading(false);
        setFund(false);
        setAddCus(false);
        setFunding({
          customerWallet: "",
          bank: "",
        });
      })
      .catch((err) => {
        setLoading(false);
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {

          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  const [opDE, setopDE] = useState(false);
  const [customer, setCustomer] = useState({});

  const handleopeing = (cusId: any) => {
    setopDE(!opDE);
  };

  const handlClose = () => {
    setopDE(false);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [openBank, setOpenBank] = useState(false);
  const [banks, setBanks] = useState({});

  return (
    <div className="board">
      <ToastContainer />
      <TopNav title="Customer" />
      {reLogin ? <ReLoginModal /> : null}
      <div className="customerPage">
        <button className="cuspageBtn" onClick={handleCus}>
          <FaUser />
          <span>Add Customer</span>
        </button>

        <div
          className="method"
          style={{
            justifyContent: "flex-end",
            marginBottom: "30px",
            marginRight: "20px",
          }}
        >
          <div className="apInput">
            <input
              type="text"
              style={{ background: "transparent" }}
              value={searchQuery}
              placeholder="search by name"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <BsSearch className="apIcon" />
          </div>
        </div>

        <div className="cosList">
          {getCustomer.length === 0 ? (
            <div className="empty">
              <FiUsers className="emptyIcon" />
              <p>No Customer Added</p>
            </div>
          ) : (
            getCustomer
              .filter((user) =>
                user.businessName
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
              .reverse()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((user: any, ind: any) => {
                const totalAmount = user?.customerAccount?.reduce(
                  (total: any, account: any) => total + account.balance?.amount,
                  0
                );
                const totalQuan = user?.customerAccount?.reduce(
                  (total: any, account: any) =>
                    total + account.balance?.quantity,
                  0
                );
                const roundedTotalQuan = totalQuan?.toFixed(2);
                return (
                  <div key={ind} className="cusCon">
                    {selectedCustomer?._id === user._id && option ? (
                      <Option
                        selectedCustomer={selectedCustomer}
                        setOption={setOption}
                        setOpenBank={setOpenBank}
                        setBanks={setBanks}
                        banks={banks}
                        openBank={openBank} user={undefined} />
                    ) : null}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="cusHead">
                        <span>
                          {user.businessName.slice(0, 2).toUpperCase()}
                        </span>
                        <p>{user.businessName}</p>
                      </div>
                      <BiDotsVerticalRounded
                        className="dot"
                        onClick={() => handleOption(user)}
                      />
                    </div>
                    <div className="walBal">
                      <div>
                        <h4>Total Balance</h4>
                        {/* {userRole === "seniorstaff" ? ( */}
                        <h5>₦{totalAmount}</h5>
                        {/* ) : (
                          <h5>Restricted</h5>
                        )} */}
                      </div>
                      <h4>Total Quantities</h4>
                      <h5>{roundedTotalQuan}</h5>
                    </div>
                    <div className="cusBtm" style={{ marginBottom: "1em" }}>
                      <span onClick={() => handleFund(user)}>
                        <FaPlus />
                        Pay to existing bank
                      </span>
                      <span
                        onClick={() => {
                          setopDE(!opDE);
                          setCustomer(user);
                        }}
                      >
                        Edit User
                      </span>
                    </div>
                    <div className="cusBtm"></div>
                  </div>
                );
              })
          )}
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={getCustomer.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      {addCus ? (
        <AddCustomer
          handleChanges={handleChanges}
          handleSubmit={handleSubmit}
          handleCus={handleCus}
          loading={loading}
          sign={sign}
        />
      ) : null}

      {fund ? (
        <FundWallet
          handleFundChange={handleFundChange}
          handleFundSubmit={handleFundSubmit}
          loading={loading}
          funding={funding}
          setFund={setFund}
          handleFund={handleFund}
          getUserBank={getUserBank}
        />
      ) : null}

      {opDE ? (
        <EditDelete
          loading={loading}
          handleChanges={handleChanges}
          handleopeing={handleopeing}
          handlClose={handlClose}
          customer={customer}
        />
      ) : null}
      {openBank ? <BanksTable banks={banks} setOpenBank={setOpenBank} /> : null}
    </div>
  );
};

export default Customers;
